<template>
  <div id="custom-table-list" class="custom-table-container">
    <vs-popup title="Enviar Email de Teste" :active.sync="isPopupActive">
      <test-campaign-popup
        @sendTestMail="sendTestMail"
      />
    </vs-popup>

    <vs-popup title="Enviar Campanha" :active.sync="isSendPopupActive">
      <send-campaign-popup
        :campaignTitle="selectedCampaignTitle"
        :campaignId="selectedCampaignId"
        @sendCampaign="sendCampaign"
      />
    </vs-popup>

    <vs-popup title="Informações da Campanha" :active.sync="isInfosPopupActive">
      <infos-campaign-popup
        :campaignId="selectedCampaignId"
      />
    </vs-popup>

    <vs-table
      ref="table"
      multiple
      :sst="true"
      @sort="handleSort"
      @search="handleSearch"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      search
      :data="campaigns"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          @emitAddNewData="addNewData"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th sort-key="title">Título</vs-th>
        <vs-th sort-key="subject_line">Assunto</vs-th>
        <vs-th>Criada Em</vs-th>
        <vs-th>Enviada Em</vs-th>
        <vs-th>Ativo</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium">{{ tr.title }}</p>
              <p><small>{{ tr.preview_text }}</small></p>
            </vs-td>

            <vs-td>
              <p class="product-subject font-medium">{{ tr.subject_line }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.created_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.sent_at) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-activated font-medium">
                <ActiveItem :active="tr.activated" />
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr.id)"
                title="Editar"
                v-if="!tr.sent_at"
              />
              <feather-icon
                v-else
                icon="EditIcon"
                svgClasses="w-5 h-5 ml-1 mr-1 stroke-current"
                title="Campanha já enviada"
                style="color: #ccc"
              />
              <feather-icon
                icon="MailIcon"
                svgClasses="w-5 h-5 ml-2 hover:text-primary stroke-current"
                @click.stop="openTestPopup(tr.id)"
                title="Enviar Email de Teste"
                v-if="!tr.sent_at"
              />
              <feather-icon
                v-else
                icon="MailIcon"
                svgClasses="w-5 h-5 ml-1 mr-1 stroke-current"
                title="Campanha já enviada"
                style="color: #ccc"
              />
              <feather-icon
                icon="SendIcon"
                svgClasses="w-5 h-5 ml-2 mr-2 hover:text-primary stroke-current"
                @click.stop="openSendPopup(tr.id, tr.title)"
                title="Enviar Campanha aos Assinantes"
                v-if="!tr.sent_at && subscribers.length"
              />
              <feather-icon
                v-else
                icon="SendIcon"
                svgClasses="w-5 h-5 ml-1 mr-1 stroke-current"
                :title="getIconTitle()"
                style="color: #ccc"
              />
              <feather-icon
                icon="InfoIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="openInfosPopup(tr.id)"
                title="Informações Sobre a Campanha"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import HeaderList from '@/views/components/custom/HeaderList'
  import TestCampaignPopup from './TestCampaignPopup';
  import SendCampaignPopup from './SendCampaignPopup';
  import InfosCampaignPopup from './InfosCampaignPopup';

  import moduleCampaign from '@/store/newsletter/campaign/moduleCampaign'
  import moduleSubscriber from '@/store/newsletter/subscriber/moduleSubscriber'
  import { defineSortFieldDirection, formatDate } from '@/utils'

  export default {
    name: 'campaigns-list',
    components: {
      ActiveItem,
      HeaderList,
      TestCampaignPopup,
      SendCampaignPopup,
      InfosCampaignPopup
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        sidebarData: {},
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        },
        isPopupActive: false,
        isSendPopupActive: false,
        isInfosPopupActive: false,
        selectedCampaignId: null,
        selectedCampaignTitle: '',
      }
    },
    watch: {
      isInfosPopupActive: function (val) {
        if (!val) {
          this.selectedCampaignId = null
          this.selectedCampaignTitle = ''
        }
      },
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    computed: {
      campaigns() {
        return this.$store.state.newsletterCampaign.campaigns
      },
      totalPages() {
        return this.$store.state.newsletterCampaign.totalPages
      },
      subscribers() {
        return this.$store.state.newsletterSubscriber.subscribers
      }
    },
    methods: {
      getIconTitle() {
        if (!this.subscribers.length) {
          return 'Não há assinantes para enviar a campanha'
        }

        return 'Campanha já enviada'
      },
      addNewData() {
        this.$router.push(`/newsletter/campaigns/choose-template`)
      },
      editData(campaignId) {
        this.$router.push(`/newsletter/campaigns/edit/${campaignId}`)
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            title: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleCampaign.isRegistered) {
          this.$store.dispatch("newsletterCampaign/fetch", {
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }

        if (moduleSubscriber.isRegistered) {
          this.$store.dispatch("newsletterSubscriber/fetch", {
            pagination_page: 1,
            pagination_limit: 1
          })
        }
      },
      openTestPopup(campaignId) {
        this.isPopupActive = true
        this.selectedCampaignId = campaignId
      },
      sendTestMail(testEmails) {
        this.$store.dispatch("newsletterCampaign/test", {
          testEmails,
          campaignId: this.selectedCampaignId
        });

        this.isPopupActive = false
        this.selectedCampaignId = null
        this.fetchData();
      },
      openSendPopup(campaignId, campaignTitle) {
        this.selectedCampaignTitle = campaignTitle
        this.isSendPopupActive = true
        this.selectedCampaignId = campaignId
      },
      sendCampaign() {
        this.$store.dispatch("newsletterCampaign/send", this.selectedCampaignId);
        this.isSendPopupActive = false
        this.selectedCampaignId = null
        this.selectedCampaignTitle = null
        this.fetchData();
      },
      openInfosPopup(campaignId) {
        this.isInfosPopupActive = true
        this.selectedCampaignId = campaignId
      },
      formatStringDate(date) {
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleCampaign.isRegistered) {
        this.$store.registerModule('newsletterCampaign', moduleCampaign)
        moduleCampaign.isRegistered = true
      }

      if (!moduleSubscriber.isRegistered) {
        this.$store.registerModule('newsletterSubscriber', moduleSubscriber)
        moduleSubscriber.isRegistered = true
      }
      
      this.fetchData();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>
